import { Box, Grid, IconButton, Typography, useTheme } from "@mui/material";
import { CircleUserRound } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { DashboardHeaderActions } from "web_myplann/Dashboard/Components/DashboardHeaderActions";
import { getDashboardGradient } from "web_myplann/Dashboard/Utils/getDashboardGradient";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { device } from "web_myplann/Utils/device";

type DashboardGradientHeaderProps = {
	title: string;
	gradientTo: string;
	gradientFrom: string;
	gradientHeight: number;
};

export const DashboardGradientHeader = ({
	title,
	gradientTo,
	gradientFrom,
	gradientHeight,
}: DashboardGradientHeaderProps) => {
	const { palette } = useTheme();
	const navigate = useNavigate();

	return (
		<>
			<Box
				sx={{
					position: "absolute",
					top: 0,
					left: 0,
					right: 0,
					height: gradientHeight,
					background: getDashboardGradient(gradientFrom, gradientTo),
					pointerEvents: "none",
					zIndex: 0,
				}}
			/>

			<Grid
				container
				direction="row"
				alignItems="center"
				px={1.6}
				mt={1}
				sx={{ position: "relative", zIndex: 1 }}
			>
				<Grid size={{ xs: 4 }}>
					<IconButton
						onClick={() => {
							navigate(Routing.Profile.ProfileDetail.path());
							device.changeDashboardColor("");
						}}
					>
						<CircleUserRound size={24} color={palette.darkmodeText.white} />
					</IconButton>
				</Grid>
				<Grid
					size={{ xs: 4 }}
					display="flex"
					justifyContent="center"
					textAlign="center"
				>
					<Typography
						fontWeight={700}
						fontSize={16}
						color={palette.darkmodeText.white}
					>
						{title}
					</Typography>
				</Grid>
				<Grid size={{ xs: 4 }} display="flex" justifyContent={"flex-end"}>
					<DashboardHeaderActions variant="gradient" />
				</Grid>
			</Grid>
		</>
	);
};
